/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArrayLike = function isArrayLike(x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};